(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alvora-linked-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-modular-family')) {
    class AoModularFamily extends HTMLElement {
      connectedCallback() {
        this.productSection = this.closest('.js-product');
        this.handleVariantChange = this.handleVariantChange.bind(this);

        this.selectedColor = this.dataset.selectedColor;

        this.productSection?.addEventListener('on:variant:change', this.handleVariantChange);
        this.syncCards(this.selectedColor);
      }

      disconnectedCallback() {
        this.productSection?.removeEventListener('on:variant:change', this.handleVariantChange);
      }

      handleVariantChange(event) {
        const variant = event.detail?.variant;
        const productData = event.detail?.product;
        if (!variant || !productData) return;

        const colorIndex = productData.options.findIndex((option) => {
          const optionName = typeof option === 'string' ? option : option.name;
          return ['color', 'colour'].includes(optionName.toLowerCase());
        });

        if (colorIndex >= 0) {
          this.selectedColor = variant.options[colorIndex];
          this.syncCards(this.selectedColor);
        }
      }

      syncCards(color) {
        this.querySelectorAll('[data-ao-family-card]').forEach((card) => {
          const variants = Array.from(card.querySelectorAll('[data-ao-family-variant]'));
          const linkedVariant = variants.find((variant) => variant.dataset.color === color) || variants[0];
          if (!linkedVariant) return;

          card.href = new URL(linkedVariant.dataset.url, window.location.origin).toString();

          const image = card.querySelector('[data-ao-family-image]');
          if (image && linkedVariant.dataset.image) {
            image.src = linkedVariant.dataset.image;
          }

          const price = card.querySelector('[data-ao-family-price]');
          if (price) price.textContent = linkedVariant.dataset.price;

          const compare = card.querySelector('[data-ao-family-compare]');
          if (compare) {
            compare.textContent = linkedVariant.dataset.compare;
            compare.hidden = !linkedVariant.dataset.compare;
          }
        });
      }

    }

    customElements.define('ao-modular-family', AoModularFamily);
  }
  } catch(e) { console.error(e); }
})();

})();
